import cn from 'classnames'
import Link from 'next/link'
// import article from 'next-seo/lib/jsonld/article'
import React, { memo } from 'react'
import CartHeader from 'src/components/global/Cart/CartHeader'
import CartHeaderTitle from 'src/components/global/Cart/CartHeaderTitle'
import { IContentItemFragment, ISolutionArticleFragment, Maybe } from 'src/graphql/generated/hooks'

import { ArticleItem } from '../ArticleItem/ArticleItem'

export interface ArticleCartProps {
  articles: Maybe<ISolutionArticleFragment>[] | any[]
  className?: string
  from?: string
}

export const ArticleCart: React.FC<ArticleCartProps> = memo(({ articles, from = 'articles' }) => {
  return (
    <div
      className={cn('w-full border-[1px] border-mist rounded-[5px]', from === 'contents' ? 'mb-[3rem]' : 'mt-[2rem]')}
    >
      <CartHeader>
        <CartHeaderTitle>{from === 'contents' ? 'Related Content' : 'Articles'}</CartHeaderTitle>
      </CartHeader>
      {from === 'articles'
        ? (articles as ISolutionArticleFragment[])
            .slice() // Make a copy of the articles before sorting to avoid mutating the original one
            .sort((articleA, articleB) => {
              const dateA = articleA?.date ? new Date(articleA.date).getTime() : 0
              const dateB = articleB?.date ? new Date(articleB.date).getTime() : 0
              return dateB - dateA
            })
            .map((article, index) =>
              article?.link ? (
                <Link href={article.link ?? '#'} key={index} target="_blank">
                  <ArticleItem article={article}></ArticleItem>
                </Link>
              ) : null,
            )
        : (articles as IContentItemFragment[]).map((article, index) =>
            article?.slug ? (
              <Link href={`/contents/${article.slug}`} key={index} scroll={true}>
                <ArticleItem article={article} from={from}></ArticleItem>
              </Link>
            ) : null,
          )}
    </div>
  )
})
